import { render, staticRenderFns } from "./FabButton.vue?vue&type=template&id=02e2a283&scoped=true&"
import script from "./FabButton.vue?vue&type=script&lang=ts&"
export * from "./FabButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e2a283",
  null
  
)

export default component.exports